import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@term glossary-id, Термин на русском}
export const TermPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;

	const alias: Record<string, string> = {
		'total-cover': 'cover',
	};

	return (
		<Link route={'glossaryItem'} params={{id: alias[id] || id}} title={title} className={linkClass('term')}>
			{title}
		</Link>
	);
};
